module.exports = __webpack_public_path__ + "img/Dantam Makeover 28.00aaae27.jpg";